import React from 'react';
import PropTypes from 'prop-types';

import { withFormik } from 'formik';
import { defaultTo, path, without, contains, slice } from 'ramda';

import styles from './styles.m.scss';

import { handleError, handleSuccess } from '../../../../../util/forms';
import { toCurrency } from '../../../../../util/helpers';
import { apiRegisterForCertification } from '../../../../../api/certification';

import Footer from '../../../../../components/Accordion/Footer';
import { apiUpdateRegistration } from '../../../../../api/registration';
import Checkbox from '../../../../../components/Forms/Checkbox';
import * as yup from 'yup';

const propTypes = {
  certification: PropTypes.object,
  updateRegistration: PropTypes.func,
  setStep: PropTypes.func,
  step: PropTypes.number,
};

const Modules = ({ certification, handleSubmit, isSubmitting, isValid, step, setFieldValue, setStep, values }) => {
  const modules = defaultTo([], certification.trainings);

  if (!modules.length) {
    return <noscript />;
  }

  return (
    <form>
      <h2 className={styles.stepHeader}>
        Each module of our financial coach training builds upon the last, enhancing your effectiveness as a financial
        coach, and therefore must be completed in order:
      </h2>
      <p>
        Please choose which modules you would like to purchase now. You may choose to purchase some of them later, but a
        discount of $300 is given if all of them are purchased at the same time.
      </p>
      {modules.map((module, index) => {
        const optionIsSelected = contains(module.id, values.modules);
        return (
          <Checkbox
            key={module.id}
            name={`modules.${module.id}`}
            checked={optionIsSelected}
            label={`Module ${module.moduleOrder}: ${module.name} (${toCurrency(module.price)})`}
            onChange={() => {
              // If the option is already selected and the last in the list, remove it
              if (optionIsSelected && index == values.modules.length - 1) {
                setFieldValue('modules', without([module.id], values.modules));
              } else {
                setFieldValue(
                  'modules',
                  slice(0, index + 1, modules).map((m) => m.id),
                );
              }
            }}
          />
        );
      })}
      <Footer step={step} setStep={setStep} isValid={isValid} isSubmitting={isSubmitting} handleSubmit={handleSubmit} />
    </form>
  );
};

Modules.propTypes = propTypes;

export default withFormik({
  handleSubmit: (payload, formProps) => {
    const { props } = formProps;
    const { certification, registration } = props;

    const createOrUpdateRegistration = registration.id ? apiUpdateRegistration : apiRegisterForCertification;
    const id = defaultTo(certification.id, registration.id);
    payload.pathwayTypeId = path(['pathwayTypes', 0, 'id'], certification);

    createOrUpdateRegistration(id, { stepName: props.name, ...payload })
      .then(({ data }) => props.updateRegistration(data))
      .then(() => handleSuccess(formProps))
      .then(() => props.setStep(props.step + 1))
      .catch((err) => handleError(formProps, err));
  },
  mapPropsToValues: ({ registration }) => ({
    modules: defaultTo([], path(['trainings'], registration)).map((training) => training.productId),
  }),
  validationSchema: () =>
    yup.object().shape({
      modules: yup.array().required().min(1),
    }),
  isInitialValid: ({ initialValues, validationSchema }) => validationSchema().isValidSync(initialValues),
  validateOnChange: true,
})(Modules);
